import "react-pdf/dist/esm/Page/AnnotationLayer.css";

const ProtectedReference = ({ refrenceRender, resourcePath }) => {
  return <div>{ refrenceRender }</div>;
};

const RestrictedResourceLink = ({
  refrenceType,
  resourcePath,
  name,
  onOpened = null,
  otherOptions = null
}) => {
  const otherOptionsPath = otherOptions
    ? `&${new URLSearchParams(otherOptions).toString()}`
    : "";
  const encodedResourcePath = encodeURIComponent(resourcePath);
  let resourceUrl = null;
  if (refrenceType == "pdf") {
    resourceUrl = `/questionnaire/pdf-file?path=${encodedResourcePath}${otherOptionsPath}`;
  } else if (refrenceType == "html") {
    resourceUrl = `/questionnaire/html-file?path=${encodedResourcePath}${otherOptionsPath}`;
  }
  const handleClick = () => {
    try {
      // Use provided onOpened callback (preferred) or fall back to store
      if (onOpened && typeof onOpened === 'function') {
        try { onOpened(); } catch (e) {}
      }
    } catch (err) {}
    window.open(resourceUrl, "_blank");
  };

  return (
    <a href="#" onClick={handleClick}>
      <span style={{ fontSize: "1.5em" }}>{name}</span>
    </a>
  );
};
export { ProtectedReference, RestrictedResourceLink };
